export const isDegenMode = (leverage: number) => leverage >= 500;
